import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_SK_UQ || "uq.sk.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_SK_UQ || 24335,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_SK_UQ || 24336,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_EU_UQ ||
    "1:160978693362:web:e3ce0b06e5d443cc47346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-2SB8ZPM5X6" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: false,
  showDualPrice: true,
  languages: [LANGUAGE.EN],
  countryRegion: "Europe/Bratislava",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2,
        "GMT+1": 1,
        "GMT+2": 2
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+1": "CET",
    "GMT+2": "CEST"
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: true
};

export default _countryEnv;
